import { adaptBoolean, adaptHtml, adaptMedia, adaptSelector } from 'adapters/base';

export const adaptFooterContent = (component, language) => {
  try {
    return {
      id: component.path,
      controlId: component.controlId,
      type: 'FooterContent',
      fields: {
        backgroundImage: adaptMedia(component.contentFields[0], 'background_image', language, 'none'),
        backgroundColor: adaptHtml(component.contentFields[0], 'background_color', language, '#fff'),
        isFullScreen: adaptBoolean(component.contentFields[0], 'fullscreen', language),
        title: adaptHtml(component.contentFields[0], 'title', language),
        marginBottom: adaptSelector(component.contentFields[0], 'margin_bottom', language, 'margin__bottom__160'),
        isFullHeight: adaptBoolean(component.contentFields[0], 'full_height', language),
        cta: __adaptCta(component.contentFields[0], 'cta', language),
        text: __adaptTextContent(component.contentFields[0], 'text_content', language),
      },
    };
  } catch (e) {
    console.error('Error adapting FooterContent component', e);
    return null;
  }
};

export const __adaptCta = (contentFields, path, language) => {
  if (!contentFields) return [];

  const contentField = contentFields.find((contentField) => contentField.path === path);

  if (!contentField?.contentFields) return [];

  return contentField.contentFields.map((field) => {
    return {
      text: adaptHtml(field, 'cta_text', language, ''),
      link: adaptHtml(field, 'cta_link', language, ''),
    };
  });
};

export const __adaptTextContent = (contentFields, path, lang) => {
  const textContentField = contentFields.find((field) => field.path === path);

  if (!textContentField) return { staticValue: [] };

  if (!textContentField.valueRaw) return { staticValue: [] };

  const value = textContentField.valueRaw.map((valueRaw) => {
    const availableLang = valueRaw.value.map((v) => v.key.toLowerCase());

    if (availableLang.includes(lang.toLowerCase())) {
      const translated = valueRaw.value.find((v) => v.key.toLowerCase() === lang.toLowerCase());
      return translated.value;
    }

    const defaultLocale = valueRaw.defaultLocale;
    const translated = valueRaw.value.find((v) => v.key === defaultLocale);
    return translated.value;
  });

  return { staticValue: value };
};
